<template>
  <v-card :class="`rounded-card card-shadow fill-height ${cardClass}`" width="100%">
    <v-card-title class="heading font-weight-bold">
      Notas fiscais
      <px-cadastro-nota-fiscal-vinculo-dialog
        v-if="!loading"
        :compra="compra"
        :links="notasFiscais"
        @change="onUpdateLinks">
        <template v-slot:activator="{ on }">
          <v-btn
            class="normal-btn-text elevation-0 rounded-tag-x-small ml-3"
            color="primary"
            x-small
            v-on="on"
          >
            Vincular NF
          </v-btn>
        </template>
      </px-cadastro-nota-fiscal-vinculo-dialog>
    </v-card-title>
    <v-card-text class="text--primary">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && notasFiscais.length">
        <div v-for="(notaFiscalLink, index) in sortedNotasFiscais"
             :key="notaFiscalLink.id">
          <px-nota-fiscal-vinculo-item :nota-fiscal-link="notaFiscalLink"
                                       @change="onUpdateLinks"/>
          <v-divider class="my-2" v-if="notasFiscais.length - 1 !== index"/>
        </div>
      </div>
      <div v-if="!loading && !notasFiscais.length">
        Nenhuma nota fiscal vinculada a esta compra.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import NotasFiscaisCompraLinkService
  from '@/modules/notas-fiscais/notas-fiscais-compra-link-service';
import NotaFiscalVinculoItem from '@/modules/notas-fiscais/vinculo/NotaFiscalVinculoItem.vue';
import CadastroNotaFiscalVinculoDialog
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoDialog.vue';

export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    cardClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      notasFiscais: [],
    };
  },
  computed: {
    sortedNotasFiscais() {
      return this.notasFiscais.slice()
        .sort((a, b) => new Date(a.createdIn) - new Date(b.createdIn));
    },
  },
  methods: {
    onUpdateLinks() {
      this.getNotasFiscaisCompra();
    },
    getNotasFiscaisCompra() {
      this.loading = true;
      NotasFiscaisCompraLinkService.getLinks(this.compra.id)
        .then(({ data }) => {
          this.notasFiscais = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getNotasFiscaisCompra();
  },
  components: {
    pxNotaFiscalVinculoItem: NotaFiscalVinculoItem,
    pxCadastroNotaFiscalVinculoDialog: CadastroNotaFiscalVinculoDialog,
  },
};
</script>
